import {Button, Card, css, styled} from '@mui/material';
import Icon from 'presentation/icons';
import {SelectCardListProps} from './types';

const SelectCardList = styled(Card)<SelectCardListProps>`
	border: 1px solid transparent;
	min-height: 68px;
	display: flex;
	flex-direction: column;
	justify-content: center;

	${({selected, theme}) =>
		selected &&
		css`
			border: 1px solid ${theme.palette.success.main};
		`}
`;

const StyledIcon = styled(Icon)`
	flex-shrink: 0;
	margin-left: auto;
`;

const StyledButton = styled(Button)`
	padding: 0;
	margin-right: auto;
	text-decoration: underline;
	font-size: 14px;
	line-height: 1;
	letter-spacing: 0.15px;
	color: ${({theme}) => theme.palette.text.secondary};
`;

export {SelectCardList, StyledIcon, StyledButton};
